import React, { useState } from 'react';

import { encode, decode } from 'html-entities';

import { ClosableBadge, EditInline } from 'components/UI';

interface IDescriptionProps {
  description: ICarePlanDescription;
  handleEditDescription: any;
  postEditCarePlan: any;
  dataTestId: string;
  disabled?: boolean;
}

const Description = ({
  description,
  handleEditDescription,
  postEditCarePlan,
  dataTestId,
  disabled
}: IDescriptionProps) => {
  const [editing, setEditing] = useState<boolean>(!description.description_id);

  const handleSave = async (value: string) => {
    const newDescription = {
      description_id: description.description_id,
      description: encode(value),
      edit_status: description.edit_status === 'new' ? 'new' : 'updated'
    };

    const res = await postEditCarePlan({
      data: {
        carePlan: {
          care_plan_id: description.care_plan_id,
          edit_status: description.care_plan_id ? 'updated' : 'new',
          descriptions: [{ ...newDescription }]
        }
      }
    });
    handleEditDescription(res.data.carePlan.descriptions[0]);
  };

  const handleDelete = async () => {
    const oldDescription = {
      description_id: description.description_id,
      edit_status: 'deleted',
      description: description.description
    };
    await postEditCarePlan({
      data: {
        carePlan: {
          care_plan_id: description.care_plan_id,
          edit_status: 'updated',
          descriptions: [{ ...oldDescription }]
        }
      }
    });
    handleEditDescription(oldDescription);
  };

  const handleBlur = () => {
    handleEditDescription();
  };

  return (
    <ClosableBadge
      label={
        <EditInline
          defaultValue={decode(description.description)}
          onChange={handleSave}
          isEditing={!description.description_id}
          onBlur={handleBlur}
          editingStatus={(editing) => setEditing(editing)}
          editingEnabled={false}
        />
      }
      bg="blue-light"
      dataTestId={dataTestId}
      onDelete={editing || disabled ? null : handleDelete}
      className="font-weight-bolder white-space-break-spaces text-left m-1 cursor-pointer"
    />
  );
};

export default Description;
